"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceLineGroup = class InvoiceLineGroup extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    groupId;
    onGroup_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("groupId");
    }
    isDefaultGroup;
    onIs_default_group(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("isDefaultGroup");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.groupId
            ? this.$fn.fetch('read_invoice_line_group', { asResource: true, parameters: { id: this.groupId } })
            : this.$fn.schemaDefaults('CreateInvoiceLineGroup', {
                invoice_id: this.invoice.id,
                is_default_group: this.isDefaultGroup
            });
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    expenseTypes;
    async $$load_expenseTypes() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'expense-type' } }).then(d => _.orderBy(d, ['name']));
    }
    titles;
    ux;
    b_7315092382398562_modalBindings;
    b_7307096920626688_dataSource;
    b_3119842801924129_dataSource;
    b_4994395583501828_dataSource;
    b_2260153975480357_dataSource;
    dataMembers = ['item', 'formId', 'formName', 'expenseTypes', 'titles', 'ux', 'b_7315092382398562_modalBindings', 'b_7307096920626688_dataSource', 'b_3119842801924129_dataSource', 'b_4994395583501828_dataSource', 'b_2260153975480357_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formId: null,
                formName: "invoiceLineGroup",
                expenseTypes: null,
                titles: {
                    incoming: this.$fn.pgettext("Invoice", "Create Incoming Invoice"),
                    outgoing: this.$fn.pgettext("Invoice", "Create Outgoing Invoice"),
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_7307096920626688_dataSource: {
                    name: "suggest_rental",
                },
                b_3119842801924129_dataSource: {
                    name: "suggest_property",
                },
                b_4994395583501828_dataSource: {
                    name: "suggest_worksheet",
                },
                b_2260153975480357_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                        contractors_only: true,
                    },
                },
            },
        };
    }
    get incomingInvoice() {
        if (this.loaded) {
            return this.invoiceKind === 'incoming';
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.isNew && this.$fn.pgettext("InvoiceLineGroup", "New line group"),
                    !this.item.isNew && this.$fn.pgettext("InvoiceLineGroup", "Edit line group"),
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7224_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_7230_getActionArgs($event) {
        return {
            result: {
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_7228_getActionArgs($event) {
        return {
            objectType: "invoice_line_group",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_7232_getActionArgs($event) {
        return {
            result: {
                value: {
                    deleted: true,
                },
            },
        };
    }
    async evh_1548630417156826_success(event, scope) {
        return await this.actions.evh_1548630417156826_success.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_7234_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7224 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7224_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7223 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7224,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7223],
        });
        const act_2248226175642056_closeModal_7226 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_7225 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_7226,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7225],
        });
        const act_1040167445267876_closeModal_7230 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_7230_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7229 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_7230,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_7228 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_7228_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_7229],
        });
        const evh_1040167445267876_submit_7227 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_7228,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_7227],
        });
        const act_1548630417156826_closeModal_7232 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_7232_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_7231 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_7232,
            event: "success",
            displayName: "closeModal",
        });
        const evh_1548630417156826_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_success_7231],
        });
        const act_2186679009640457_closeModal_7234 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_7234_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_7233 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_7234,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_7233],
        });
        return {
            act_7315092382398562_closeModal_7224,
            evh_7315092382398562_close_7223,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_7226,
            evh_2248226175642056_close_7225,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_7230,
            evh_1040167445267876_success_7229,
            act_1040167445267876_crud_7228,
            evh_1040167445267876_submit_7227,
            evh_1040167445267876_submit,
            act_1548630417156826_closeModal_7232,
            evh_1548630417156826_success_7231,
            evh_1548630417156826_success,
            act_2186679009640457_closeModal_7234,
            evh_2186679009640457_clickPreventStop_7233,
            evh_2186679009640457_clickPreventStop,
            submit: act_1040167445267876_crud_7228,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], InvoiceLineGroup.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineGroup.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLineGroup.prototype, "groupId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('groupId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineGroup.prototype, "onGroup_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], InvoiceLineGroup.prototype, "isDefaultGroup", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isDefaultGroup'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineGroup.prototype, "onIs_default_group", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], InvoiceLineGroup.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineGroup.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], InvoiceLineGroup.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineGroup.prototype, "onSize", null);
InvoiceLineGroup = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceLineGroup);
exports.default = InvoiceLineGroup;
vue_property_decorator_1.Vue.component("InvoiceLineGroup", InvoiceLineGroup);
